module.exports = __webpack_public_path__ + "static/sendgrid-2af6cd70bc1f80ee458f70e9733ff01f.jpg";